/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AIPlaygroundListModelsRequest {
    getFixupPrototypeFunction() { return AIPlaygroundListModelsRequest.fixupPrototype; }

    static newInstance(model: Partial<AIPlaygroundListModelsRequest>): AIPlaygroundListModelsRequest {
        let obj = Object.assign(new AIPlaygroundListModelsRequest(), model);
        AIPlaygroundListModelsRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AIPlaygroundListModelsRequest>): AIPlaygroundListModelsRequest {
        if (!model) return null;
        return AIPlaygroundListModelsRequest.newInstance(<AIPlaygroundListModelsRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AIPlaygroundListModelsRequest) {
        if (!obj) return;

        models.AIPlaygroundListModelsRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AIPlaygroundListModelsRequest): boolean {
        Object.setPrototypeOf(obj, AIPlaygroundListModelsRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Hyperscaler service name
     */
    service_name: models.CloudServiceName;

    /**
     * Hyperscaler region
     */
    region: string;

}
